import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import textUtils from "@mnjsplatform/data/lib/utils/textUtils";
import ReportPlaceholder from "../../Common/ReportPlaceholder";
import i18next from "i18next";

class SubAccessMatrix extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedTabNum: null
        };
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.listWSForPO.reset());
            await this.props.dispatch(this.props.listAddWSForPO.reset());
            await this.props.dispatch(this.props.listSubForPO.reset());

            await this.props.dispatch(this.props.listSubForPO.execute({}, {withParams: true}));
        } catch (e) {
            console.error(e);
        }
    }

    renderParam = (h) => {
        return (<>
            <div className="row mb-2">
                <div className="col-md-4">
                    {/*Количество уровней подчиненности (<span style={{color: "red"}}>не более 5 уровней</span>):*/}
                    {h.lbl("NumSub")}
                </div>
                <div className="col-md-1">
                    {h.ed("NumSub")}
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-12">
                    {h.ed("AdmStructName")}
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-4">
                    {i18next.t("SubordinateSearch")}:
                </div>
                <div className="col-md-8" style={{height: "32px"}}>
                    <SearchBar dataItem={this.props.listSubForPO}
                               afterApplyValue={this.afterApplyFilter}
                    />
                </div>
            </div>
        </>);
    };

    onSelectPerson = async (rowIndex, row, e) => {
        await this.getPersonData(row.TabNum);
        this.setState({selectedTabNum: row.TabNum});
    };

    getPersonData = async (tabNum) => {
        if (tabNum) {
            try {
                await this.props.dispatch(this.props.listWSForPO.execute({"SubTabNum": tabNum}));
                await this.props.dispatch(this.props.listAddWSForPO.execute({"SubTabNum": tabNum}));
            } catch (e) {
                console.log(e);
            }
        }
    };

    gridRowStyleProvider = (rowIndex, row) => {
        if (this.state.selectedTabNum && this.state.selectedTabNum === row.TabNum) {
            return {fontWeight: "bold", backgroundColor: "lightgrey"};
        }
        return {};
    };

    afterApplyFilter = () => {
        if (this.props.listSubForPO.isInitialized && this.state.selectedTabNum && !this.props.listSubForPO.dataTable().some(r => r.TabNum === this.state.selectedTabNum)) {
            this.setState({selectedTabNum: null});
        }
    };

    renderParamsReport = (h) => {
        return (<div className="row">
            <div className="col-md-4">
                {h.lbl("CheckAsLevel")}
            </div>
            <div className="col-md-1">
                {h.ed("CheckAsLevel")}
            </div>
        </div>);
    };

    renderReport = () => {
        return (<PlaceholderWrapper placeholderId="20"
                                    title={<><i className='fa fa-table'/> {i18next.t("Report")}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}
        >
            <ReportPlaceholder reportKey="RMatrixBossWsPO" reportId="RMatrixBossWsPO" title={i18next.t("SubDepartmentsAccessMatrix")}>
                {(reportParamsItem, build) => {
                    return (<>
                        <ComplexParam dataItem={reportParamsItem}
                                      readOnly={false}
                                      showSearchBar={false}
                                      showApplyButton={false}
                                      autoApplyParams={false}
                                      rootPath="/"
                                      renderParams={this.renderParamsReport}
                        />
                        <button className="btn mn-btn-link" onClick={async (e) => {
                            e.preventDefault();

                            await this.props.dispatch(reportParamsItem.setField(0, "CheckPercent", 50));

                            await build();
                        }}>
                            {i18next.t("SubDepartmentsAccessMatrix")}
                        </button>
                    </>);
                }}
            </ReportPlaceholder>
        </PlaceholderWrapper>);
    };

    renderAccessMatrix = () => {
        if (!this.state.selectedTabNum) {
            return null;
        }

        const style = Object.assign({
            backgroundColor: "#fff",
            cursor: "pointer",
            ':active': {color: "#495057", borderColor: "#dee2e6 #dee2e6 #fff"}
        });
        return (<PlaceholderWrapper placeholderId="50"
                                    title={<><i className='fa fa-table'/> {i18next.t("WorkingPlaces")}</>}
                                    showSplitterLine={false}
                                    canCollapse={false}
        >
            <ul className="nav nav-tabs" role="tablist" id="nav-tab">
                <li className="nav-item" key="ListWSForPO">
                    <a id="ListWSForPO-tab" data-toggle="tab" href="#ListWSForPO"
                       className="nav-link active"
                       style={style} role="tab"
                       aria-controls="ListWSForPO" aria-selected="true">{i18next.t("StandardMatrixPositions")}</a>
                </li>
                <li className="nav-item" key="ListAddWSForPO">
                    <a id="ListAddWSForPO-tab" data-toggle="tab" href="#ListAddWSForPO" className="nav-link"
                       style={style} role="tab"
                       aria-controls="ListAddWSForPO"
                       aria-selected="false">{i18next.t("AdditionalWorkingPlaces")}</a>
                </li>
            </ul>
            <div className="tab-content">
                <div id="ListWSForPO" className="tab-pane show active inwhite card" role="tabpanel"
                     aria-labelledby="ListWSForPO-tab">
                    <GridView dataItem={this.props.listWSForPO}/>
                </div>
                <div id="ListAddWSForPO" className="tab-pane inwhite card" role="tabpanel"
                     aria-labelledby="ListAddWSForPO-tab">
                    <GridView dataItem={this.props.listAddWSForPO}/>
                </div>
            </div>
        </PlaceholderWrapper>);
    };

    render() {
        let cnt = this.props.listSubForPO.rowsCount();
        let gridTitleText = i18next.t("SubordinateList_GridTitle", {people_count: textUtils.pluralize_i18next(cnt, "peopleCountPostfix")});

        return (<>
            {/*<PlaceholderWrapper placeholderId="10"
                                    title={<><i className='fa fa-info'/> {i18next.t("SubAccessMatrix_Instruction")}</>}
                                    showSplitterLine={false}
                                    canCollapse={true}
                >
                    Для того чтобы ваши новые подчиненные смогли приступить к работе в первый же день и <span
                    style={{fontWeight: 'bold', textDecoration: 'underline'}}>Вы получили</span> автоматическую рассылку
                    о проверке доступа к рабочим местам <span style={{fontWeight: 'bold', textDecoration: 'underline'}}>Вам необходимо</span>:
                    <ul>
                        <li>Выбрать, в полученном файле по каждой позиции рабочие места, которые сейчас отмечены в
                            качестве дополнительных, но являются необходимыми для выполнения функционала для всех
                            сотрудников данной должности и перевести их в стандартные.
                        </li>
                        <li>Для этого необходимо оформить <span
                            style={{fontWeight: 'bold', textDecoration: 'underline'}}>в «Лотусе» заявку на изменение (создание) матрицы доступа</span>.
                        </li>
                        <li>Если какие-либо РМ из полученного списка не используются вашими сотрудниками,
                            необходимо <span
                                style={{fontWeight: 'bold', textDecoration: 'underline'}}>обязательно</span> сообщить об
                            этом, отправив письмо на адрес <a target="_blank" href="mailto:RUSDIT_AC05a@baltika.com"
                                                              rel="noopener noreferrer">RUSDIT_AC05a@baltika.com</a>,
                            указав в нем ФИО сотрудника и наименование лишних РМ. Они будут отключены.
                        </li>
                    </ul>
                    <p style={{color: 'red'}}>
                        Руководитель несет персональную ответственность за наличие у сотрудников адекватных рабочих
                        мест, поэтому настоятельно рекомендуем сделать это не откладывая. На более позднем этапе
                        согласование доступов к дополнительным РМ придется запускать вручную.
                    </p>
                </PlaceholderWrapper>*/}

            {this.renderReport()}

            <PlaceholderWrapper placeholderId="30"
                                title={<><i className='fa fa-filter'/> {i18next.t('Filters')}</>}
                                showSplitterLine={false}
                                canCollapse={false}
            >
                <ComplexParam dataItem={this.props.listSubForPOParams}
                              readOnly={false}
                              showSearchBar={false}
                              showApplyButton={false}
                              autoApplyParams={true}
                              rootPath="/"
                              parentDataItem={this.props.listSubForPO}
                              renderParams={this.renderParam}
                              afterApplyParams={this.afterApplyFilter}
                />
            </PlaceholderWrapper>

            <PlaceholderWrapper placeholderId="40"
                                title={<><i className='fa fa-table'/> {gridTitleText}</>}
                                staticTitle={i18next.t("SubordinateList_GridTitle", {people_count:''})}
                                showSplitterLine={false}
                                canCollapse={false}
            >
                <GridView dataItem={this.props.listSubForPO}
                          onRowClick={this.onSelectPerson}
                          updateStateFlag={{tabNum: this.state.selectedTabNum}}
                          overrideVisibility={{IsChecked: false}}
                          rowStyleProvider={this.gridRowStyleProvider}
                />
            </PlaceholderWrapper>

            {this.renderAccessMatrix()}
        </>);
    }
}

SubAccessMatrix.propTypes = {
    dispatch: PropTypes.func.isRequired,
    listSubForPO: PropTypes.object,
    listSubForPOParams: PropTypes.object,
    listWSForPO: PropTypes.object,
    listAddWSForPO: PropTypes.object
};

SubAccessMatrix.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        listSubForPO: state.subAccessMatrixState.EmployeesAccessMatrix_ListSubForPO,
        listSubForPOParams: state.subAccessMatrixState.EmployeesAccessMatrix_ListSubForPOParams,
        listWSForPO: state.subAccessMatrixState.EmployeesAccessMatrix_ListWSForPO,
        listAddWSForPO: state.subAccessMatrixState.EmployeesAccessMatrix_ListAddWSForPO
    }
}

export default connect(mapStateToProps)(SubAccessMatrix);